import { FC } from 'react';
import formatEstimatedWaitTime from '@pages/monitoring/QueuesPage/utils/formatEstimatedWaitTime';
import { QueueRow } from './types';

interface EstimatedWaitCellProps {
  dataItem: QueueRow;
}

const EstimatedWaitCell: FC<EstimatedWaitCellProps> = ({ dataItem }) => (
  <td>{formatEstimatedWaitTime(dataItem.estimatedWait)}</td>
);

export default EstimatedWaitCell;
